// react-native-sound -> HTMLAudioElement. Sounds are served from the site root.
function Sound(file, basePath, onLoad) {
  this.audio = typeof Audio !== "undefined" ? new Audio("/" + file) : null;
  if (this.audio) {
    this.audio.preload = "auto";
  }
  if (typeof basePath === "function") {
    basePath(null);
  } else if (typeof onLoad === "function") {
    onLoad(null);
  }
}

Sound.prototype.play = function(onEnd) {
  if (!this.audio) {
    return this;
  }
  try {
    this.audio.currentTime = 0;
    const result = this.audio.play();
    if (result && result.catch) {
      result.catch(() => {});
    }
    if (onEnd) {
      this.audio.onended = () => onEnd(true);
    }
  } catch (e) {
    // autoplay restrictions, ignore
  }
  return this;
};
Sound.prototype.stop = function() {
  if (this.audio) {
    this.audio.pause();
  }
  return this;
};
Sound.prototype.release = function() {
  return this;
};
Sound.prototype.setVolume = function(v) {
  if (this.audio) {
    this.audio.volume = v;
  }
  return this;
};

Sound.setCategory = function() {};
Sound.MAIN_BUNDLE = "";
Sound.DOCUMENT = "";

module.exports = Sound;
